import cn from 'classnames';
import BrokenLink from '@crehana/icons/pictograms/BrokenLink';
import Configure from '@crehana/icons/pictograms/Configure';
import Delete2 from '@crehana/icons/pictograms/Delete2';
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var decorationIcons = [Delete2, BrokenLink, Configure];
var ErrorOverlay = function ErrorOverlay() {
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi,
    header = _useUIContext.header;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('cp-error-overlay absolute flex flex-col items-center justify-center text-center inset-0 px-32 bg-base-main-80 text-white', visibleUi ? 'z-3' : 'z-4'),
    style: header && playerSize.matches.xs ? {
      paddingTop: '10%'
    } : undefined,
    children: [playerSize.matches.sm && /*#__PURE__*/_jsx("div", {
      className: "flex items-center mb-24",
      "data-testid": "decoration-icons",
      children: decorationIcons.map(function (Icon, i) {
        return /*#__PURE__*/_jsx("div", {
          className: cn('flex items-center justify-center flex-shrink-0 w-56 h-56 bg-base-lighter-16 text-secondary-light rounded-5', {
            'mr-20': i < decorationIcons.length - 1
          }),
          children: /*#__PURE__*/_jsx(Icon, {
            size: 32,
            className: "fill-current",
            ignoreColor: true
          })
        }, "player-icon-".concat(i * 1));
      })
    }), /*#__PURE__*/_jsx("h4", {
      className: cn('font-subtitle2', playerSize.matches.md ? 'mb-8' : 'mb-4'),
      children: t('ERROR_TITLE')
    }), /*#__PURE__*/_jsx("p", {
      className: "font-body3",
      children: t('ERROR_DESC')
    })]
  });
};
export default ErrorOverlay;